import { Component, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ApiService } from 'src/app/shared/services/api.service';
import { Editor, Toolbar } from 'ngx-editor';

@Component({
  selector: 'app-package-form',
  templateUrl: './package-form.component.html',
  styleUrls: ['./package-form.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class PackageFormComponent implements OnInit, OnDestroy {
  packageForm!: FormGroup;
  isEditMode = false;
  packageId!: number;
  submitted = false;

  descriptionEditor!: Editor;
  sExclusionEditor: Editor;
  toolbar: Toolbar = [
    ['bold', 'italic'],
    ['underline', 'strike'],
    ['code', 'blockquote'],
    ['ordered_list', 'bullet_list'],
    [{ heading: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] }],
    ['link', 'image'],
    ['text_color', 'background_color'],
    ['align_left', 'align_center', 'align_right', 'align_justify'],
  ];
  durationOptions = [
    { label: 'Monthly', value: 30 },
    { label: 'Quarterly', value: 90 },
    { label: 'Half-Yearly', value: 180 },
    { label: 'Yearly', value: 360 },
  ];

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private apiService: ApiService,
    private toastService: ToastrService
  ) { }

  ngOnInit(): void {
    this.initializeForm();
    this.descriptionEditor = new Editor();

    this.route.paramMap.subscribe(params => {
      const id = params.get('id');
      if (id) {
        this.isEditMode = true;
        this.packageId = +id;
        this.loadPackage(this.packageId);
      }
    });
  }

  ngOnDestroy(): void {
    if (this.descriptionEditor) {
      this.descriptionEditor.destroy();
    }
    if (!this.sExclusionEditor) {
      this.sExclusionEditor?.destroy();
    }
  }

  initializeForm(): void {
    this.packageForm = this.fb.group({
      package_name: ['', Validators.required],
      description: [''],
      sqr_amount: [1, [Validators.required, Validators.min(0)]],
      user_count: [1, [Validators.required, Validators.min(0)]],
      project_count: [1, [Validators.required, Validators.min(0)]],
      invoice_count: [0,[]],// [Validators.required, Validators.min(0)]],
      duration: [30],// Validators.required],
      per_user_price: [0, [Validators.required, Validators.min(0)]],
      s_exclusion: ['']
    });
  }

  loadPackage(id: number): void {
    this.apiService.getPackageDetailsById(id).subscribe(pkg => {
      this.packageForm.patchValue({
        ...pkg,
        duration: pkg.duration
      });
    });
  }

  onSubmit(): void {
    this.submitted = true;

    if (this.packageForm.invalid) {
      this.toastService.error('Please fill all required fields');
      return;
    }



    if (this.isEditMode) {
      this.apiService.updatePackage(this.packageId, this.packageForm.value).subscribe({
        next: () => {
          this.toastService.success('Package updated successfully');
          this.router.navigate(['/home/package-list']);
        },
        error: () => {
          this.toastService.error('Failed to update package');
        },
      });
    } else {
      this.apiService.createPackage(this.packageForm.value).subscribe({
        next: () => {
          this.toastService.success('Package created successfully');
          this.router.navigate(['/home/package-list']);
        },
        error: () => {
          this.toastService.error('Failed to create package');
        },
      });
    }
  }

  get f() {
    return this.packageForm.controls;
  }
}
